import { Menu } from '../../../components'
import { useTranslation } from 'react-i18next'

type ChatPageOptionsMenuProps = {
  onDeleteChatClick: () => void
}

export function ChatPageOptionsMenu (props: ChatPageOptionsMenuProps) {
  const { onDeleteChatClick } = props

  const { t } = useTranslation()

  return (
    <Menu>
      <li>
        <a onClick={onDeleteChatClick}>
          {t('chatPage:Delete chat')}
        </a>
      </li>
    </Menu>
  )
}
